const GoUp = () => {
    window.location.href = "#"
}

export default GoUp